
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'RotateAnimation',
  props: [
    'data',
    'type'
  ],
});
